export function handleMemberByKey(curObj, mapArr) {
    curObj = JSON.parse(JSON.stringify(curObj))
    var curPath = null
    //递归循环
    recursion(curObj);
    function recursion(curObj) {
        if (getType(curObj) === 'Array') { curObj.forEach(e => { ; recursion(e) }); return };
        addMember(mapArr, curObj)
        Object.keys(curObj).forEach(key => {
            let type = getType(curObj[key])
            if (type === 'Array' || type === 'Object') { type === 'Array' ? curPath = curObj.path : null;; recursion(curObj[key]); }
            mapArr.forEach(e => {
                if (Object.keys(e)[0] === key && e.config !== 'add') {
                    if (e.config == 'copy') { curObj[e[key]] = (e.handle && e.handle(curObj)) || curObj[key] }
                    else if (e.config == 'replace') { e[key].length ? curObj[e[key]] = (e.handle && e.handle(curObj, curPath)) || curObj[key] : null; e.handle || delete curObj[key] }
                }
            })
        })
    }
    function addMember(mapArr, curObj) { mapArr.forEach((e, i) => { if (e.config === 'add') { curObj[Object.keys(e)[0]] = Object.values(e)[0] } }) }
    function getType(obj) { return Object.prototype.toString.call(obj).slice(8, -1) }
    return curObj;
}

// 函数说明：这是一个可以同时深度 批量拷贝属性，批量替换key，批量删除属性，批量函数式修改属性，批量新增属性的方法
// 参数说明:  originObj:目标对象（必须）,  mapArr:匹配数组（必须）
// mapArr（拷贝）：[{要拷贝的key :   '目标key' ，config:'copy'},.....]           ：将目标属性值拷贝到新key上 
// mapArr（替换）:  [{要替换的key  :   '新key'    ，config:'replace'}},......]     ：将目标key替换成新的key 
// mapArr（删除）:  [{要删除的key ：‘’         ， config:'replace'}},......]     :  将目标key删除
// mapArr（函数式修改）:  [{要修改的key  :   '要修改的key'  ，config:'replace'，handle:(e)=>{}   }},......] ：使用函数，修改一个属性的值，可以是复杂操作
// mapArr（新增）:  [{要新增的key  :   '新key'    ，config:'add'}},......]           ：新增一个成员属性并赋值


// 注意：删除配置参数是replace，删除操作只需要把值置为空字符串即可

// 示例 ：
var obj: object = {}

var finObj = handleMemberByKey(obj, [{ href: '', config: 'replace' }])                                    //   ----深度批量删除  该目标对象中所有对象  属性key为href的属性
var finObj = handleMemberByKey(obj, [{ href: 'path', config: 'replace' }])                             //   ----深度批量替换  该目标对象中所有对象  属性key为href的属性为path
var finObj = handleMemberByKey(obj, [{ href: 'path', config: 'copy' }])                               //    ----深度批量拷贝  该目标对象中所有对象  属性key为path的属性，并用key为href的属性赋值
var finObj = handleMemberByKey(obj, [{ web: 'www.google.com', config: 'add' }])             //   ----深度批量新增  该目标对象中所有对象  属性key为href的属性
var finObj = handleMemberByKey(obj, [{ web: 'web', config: 'replace', handle: (e) => e.slice(1) }])   //   ----深度批量函数式修改  该目标对象中所有对象  属性key为web的属性(例子中是将值取第一位后的字符串作为新值)

//实际用例
// var finObj = handleMemberByKey(obj,
//     [
//         {href:'path',config:'replace'},
//         {childList:'children',config:'replace'},
//         {component:'layout',config:'add'},
//         {component:'component',config:'replace',handle:(e,curPath)=>{if(curPath &&curPath!==e.path){return (curPath+e.path).slice(1)}}}]);


// handleMemberByKey(
//     handleMemberByKey(obj,
//         [
//             {href:'path',config:'replace'},
//             {childList:'children',config:'replace'},
//             {component:'layout',config:'add'},
//             {component:'component',config:'replace',
//              handle:(e,curPath)=>{
//                  if(curPath &&curPath!==e.path){
//                      return (curPath+e.path).slice(1)
//                     }
//                 }
//             }
//         ]
//         ),
//            [
//                {path:'path',config:'replace',
//                 handle:(e,curPath)=>{
//                   if(curPath &&curPath!==e.path){
//                      return e.path.slice(1)
//                     }
//                  }
//                }
//            ]
//        )


export function handleMemberByKey1(curObj, mapArr) {
    getType(curObj) === 'Array' ? curObj = { data: curObj } : null;
    var curPath = null;//用于记录当前层级
    //递归循环
    recursion(curObj);
    function recursion(curObj) {
        //如果不是复杂类型则不进入递归
        if (!(curObj instanceof Object)) return
        //如果该对象是数组，则让数组中每个元素都进入递归
        if (getType(curObj) === 'Array') { curObj.forEach(e => recursion(e)); return };
        //当config为add时，先添加到当前对象中去，在接下来遍历key时才会被选中
        addMember(mapArr, curObj)
        //拷贝当前对象的键到数组中，为了接下来的遍历
        let cArr = Object.keys(curObj);
        //处理模式mode，如果为mixed说明有属性出现多余1次的操作，则加入遍历数组中
        handleMode(mapArr, cArr)
        //将键集合遍历
        cArr.forEach(key => {
            let type = getType(curObj[key])
            //如果类型为数组或对象，则无法直接处理，需要进行递归，并记录当前层级的path值
            if (type === 'Array' || type === 'Object') { type === 'Array' ? curPath = curObj.path : null;; recursion(curObj[key]); }
            //遍历配置数组
            mapArr.forEach(e => {
                //当配置数组中配置项的键存在遍历数组中
                if (Object.keys(e)[0] === key) {
                    //用配置项的值做键，并用配置项的键在当前对象中的属性值赋值，如果有handle处理函数则用处理函数的返回值赋值
                    e[key].length && (curObj[e[key]] = (e.handle && e.handle(curObj, curPath)) || curObj[key])
                    //如果config为replace，则需要将原属性删除
                    if (e.config == 'replace') e.handle || delete curObj[key]
                }
            })
        })
    }
    //用于处理mode
    function handleMode(mapArr, cArr) { mapArr.forEach(e => e.mode || e.mode == 'mixed' ? cArr.push(Object.values(e)[0]) : null) }
    //用于新增属性
    function addMember(mapArr, curObj) { mapArr.forEach((e, i) => { if (e.config === 'add') { curObj[Object.keys(e)[0]] = Object.values(e)[0] } }) }
    //用于判断变量类型
    function getType(obj) { return Object.prototype.toString.call(obj).slice(8, -1) }
    return curObj;
}
//配置项元素有严格的顺序要求
var options = [
    { href: 'path', config: 'replace' },
    { childList: 'children', config: 'replace' },
    { component: 'layout', config: 'add' },
    { component: 'component', config: 'replace', handle: (e, curPath) => { if (curPath && curPath !== e.path) { return (curPath + e.path).slice(1) } } },
    { path: 'path', config: 'replace', mode: 'mixed', handle: (e, curPath) => { if (curPath && curPath !== e.path) { return e.path && e.path.slice(1) } } }
]